export const QR_CODE_PAD_LENGTH = 10;

export const padQRCodeValue = (value: string, length: number = QR_CODE_PAD_LENGTH): string =>
  value.padStart(length, '0');

export const padQRCodeWithPrefix = (prefix: string, id: string, length: number = QR_CODE_PAD_LENGTH): string =>
  `${prefix}${padQRCodeValue(id, length)}`;
